import * as React from 'react';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserMultiSceneDemo from 'src/games/demos/phaserMultiSceneDemo/Main';

interface MultiSceneDemoProps extends PageProps<{}> {
}

class MultiSceneDemo extends React.Component<MultiSceneDemoProps> {
    constructor(props: MultiSceneDemoProps) {
        super(props);
        bindAllOfThis(this, MultiSceneDemo.prototype);
    }

    render() {
        return (<div>
            <PhaserMultiSceneDemo />
        </div>);
    }
}

export default MultiSceneDemo;



// WEBPACK FOOTER //
// ./src/pages/game/demos/MultiSceneDemo.tsx